import { jsxs as o, jsx as e } from "react/jsx-runtime";
import { useChatbotContext as r } from "../../hooks/useChatbotContext.js";
function l() {
  const { input: n, isEditing: t } = r();
  return /* @__PURE__ */ o(
    "button",
    {
      disabled: t || !n.length,
      className: "mx-[2px] my-1.5 flex w-[42px] items-center justify-center rounded-medium bg-transparent text-foreground ring ring-transparent ring-offset-2 ring-offset-card transition-all focus-visible:outline-none focus-visible:ring-ring hover:enabled:bg-accent hover:enabled:text-accent-foreground disabled:cursor-not-allowed disabled:opacity-50 @notMobile:m-2 @notMobile:h-10 @notMobile:w-10",
      children: [
        /* @__PURE__ */ e(
          "svg",
          {
            "aria-hidden": "true",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            height: 18,
            width: 18,
            children: /* @__PURE__ */ e(
              "path",
              {
                fill: "currentColor",
                d: "M23.63 12 .97 1.27l1.46 8.31L9 12.67v2.21l-6.14-2.89V12L.97 22.73 23.63 12Z"
              }
            )
          }
        ),
        /* @__PURE__ */ e("span", { className: "sr-only", children: "Send" })
      ]
    }
  );
}
export {
  l as UserMessageSendButton
};
